// extracted by mini-css-extract-plugin
export default {"underlinedInput":"goodie-giveaway-product-quantity-input__underlinedInput___fMnem"};